import * as React from 'react';
import axios from 'axios';
import { ThisUser } from "./User";
import { UserContext } from "./user_Context";
import { defaultUser } from './userDefault';
import { Buffer } from 'buffer';
import { googleLogout, TokenResponse, useGoogleLogin } from '@react-oauth/google';
import {
  FacebookLoginButton,
  GoogleLoginButton,
  TwitterLoginButton,
  GithubLoginButton,
  InstagramLoginButton,
  LinkedInLoginButton,
  AppleLoginButton,
} from 'react-social-login-buttons';
import { Timestamp } from 'mongodb';
import PopupWindow from './PopUpWindow';

function App() {

  const [myuser, setMyUser] = React.useState<TokenResponse>();
  const [newMyUser, setNewMyUser] = React.useState(false);
  const [profile, setProfile] = React.useState<any>([]);
  const [provider, setProvider] = React.useState('');
  const { user, setUser } = React.useContext(UserContext);

  const loginGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setMyUser(codeResponse);
      setProvider("Google");
    },
    onError: (error) => {
      console.error('Login Failed:', error);
    }
  });

  const loginWithGitHub = () => {
    const clientID = process.env.REACT_APP_GITHUB_APP_ID;
    const redirectURI = `${process.env.REACT_APP_BASE_URL}/auth/github/callback`;
    window.location.href = (`https://github.com/login/oauth/authorize?client_id=${clientID}&redirect_uri=${redirectURI}`);
    /*     const popup = PopupWindow.open(
          'github-oauth-authorize',
          `https://github.com/login/oauth/authorize?client_id=${clientID}&redirect_uri=${redirectURI}`,
          { height: 1000, width: 600 }
        );
        popup.then(
          (data: any) => console.log(data),
          (error: any) => console.error(error)
        ); */
  };

  const checkSavedUser = () => {
    var provider = localStorage.getItem("provider");

    if (provider) {
      console.log("User previously logged in with " + provider);
      var given_name = localStorage.getItem("given_name");
      var family_name = localStorage.getItem("family_name");
      var handle = localStorage.getItem("handle");
      var email = localStorage.getItem("email");
      var avatar_url = localStorage.getItem("avatar_url");
      var token = localStorage.getItem("token");
      var id = localStorage.getItem("id");
      var prevuser = {
        "given_name": given_name,
        "family_name": family_name,
        "handle": handle,
        "email": email,
        "picture": avatar_url,
        "id": id,
        "token": token,
        "provider": provider
      };
      setUser(prevuser);
      setProfile(prevuser);
      setProvider(provider);
      if (provider === "Google") {
        setNewMyUser(false);
        setMyUser({
          "access_token": "ya29.a0AcM612zsxUB94bBmQeX9jhKvSRl7V-1R8mqJYjFH4RNh9Vtikeegqp7wkW43-1rcVvr8iLdlFMk4UYW-vUpQqubVJRB6jM9A9fQv0oKaJYuK7brOY5_6ZKArBRA74wpQqsuuVNrQ2PHhxNv3WuRpGkP681K31Yh73OGQaCgYKAXUSARESFQHGX2Mi1zATaWStk0yEsKxpk-LYpw0171",
          "token_type": "Bearer",
          "expires_in": 3599,
          "scope": "email profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid",
          "prompt": "none"
        });
      }
    } else {
      setNewMyUser(true);
    }
  }

  const clearLocalUser = () => {
    localStorage.removeItem("given_name");
    localStorage.removeItem("family_name");
    localStorage.removeItem("handle");
    localStorage.removeItem("email");
    localStorage.removeItem("provider");
    localStorage.removeItem("avatar_url");
    localStorage.removeItem("id");
    localStorage.removeItem("token");
  }

  // log out function to log the user out of google and set the profile array to null
  const logOut = (provider: string) => {
    setProfile([]);
    setProvider('');
    setUser(defaultUser);
    clearLocalUser();
    switch (provider) {
      case "Google":
        googleLogout();
        setMyUser(undefined);
        return;
      case "GitHub":
        return;
      default:
        return;
    }
  };

  React.useEffect(() => {
    checkSavedUser();
  }, []);

  // Google
  React.useEffect(() => {
    if (myuser && (newMyUser === true)) {
      console.log("hit");
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${myuser.access_token}`, {
        headers: {
          Authorization: `Bearer ${myuser.access_token}`,
          Accept: 'application/json'
        }
      })
        .then((res) => {
          setProvider("Google");
          setProfile(res.data);
          setNewMyUser(false);
        })
        .catch((err) => console.error(err));
    }
  },
    [myuser]
  );

  //GitHub
  React.useEffect(() => {
    if (user && user.provider === "GitHub") {
      console.log("logged in with " + user.provider)
      setProvider("GitHub");
      setProfile(user);
    }
  },
    [user]
  );

  return (
    <div>
      {(myuser && profile && provider === "Google") || (user && profile && provider === "GitHub") ? (
        <ThisUser provider={provider} profile={profile} onLogout={() => logOut(provider)} />
      ) : (
        <div className='submenu-login'>
          <GoogleLoginButton iconSize="25px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => loginGoogle()}></GoogleLoginButton>
          <GithubLoginButton iconSize="25px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => loginWithGitHub()}></GithubLoginButton>
          <TwitterLoginButton iconSize="20px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => alert("Twitter login")}></TwitterLoginButton>
          {/* <InstagramLoginButton iconSize="25px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => alert("Instagram login")}></InstagramLoginButton>
          <FacebookLoginButton iconSize="25px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => alert("Facebook login")}></FacebookLoginButton>
          <LinkedInLoginButton iconSize="25px" size="35px" style={{ width: 'calc(100% - 30px)' }} className='logonButton' onClick={() => alert("LinkedIn login")}></LinkedInLoginButton> */}
        </div>
      )}
    </div>
  );
}

export default App;